import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import itiLayoutMenuModule from '@/store/modules/iti-layout-menu.module';
import { ItiString, itiPermissionService } from '@/iti-core-vue';
import { ItiMenuItem, ItiMenuOption, ItiMenuGroup } from '@/iti-core-vuetify';
import EventBusType, { EventBus } from '@/shared/services/event-bus';


@Component({
    components: {
        ItiMenuOption,//: () => import('./option/iti-menu-option.vue'),
        ItiMenuGroup, //: () => import('./group/iti-menu-group.vue'),
    },
})
export default class PrivateMenuRootComponent extends Vue {

    @Prop({default: []}) public fullMenuOptions!: ItiMenuItem[];
    @Prop({default: 300}) public width!: number | string;

    protected menu: ItiMenuItem[] = [];

    public get imgSrcLogoSymbinet() {
        return process.env.VUE_APP_PUBLIC_PATH + 'assets/img/Symbinet.png'; //person_32x32.png';
  }
  
    public get drawer(): boolean {
        return itiLayoutMenuModule.visible;
    }

    public set drawer(newtoggle: boolean) {
        itiLayoutMenuModule.setVisible(newtoggle);
    }

    public created() {
        // Creamos el menú según los permisos del usuarios
        this.createUserMenu();
        EventBus.$on(EventBusType.updatePermissions, this.createUserMenu.bind(this));
    }

    ///
    /// Pasar del menú completo solo las opciones sobre las que se tiene permiso
    ///

    protected createUserMenu() {
        this.menu = [];
        // Recorremos las opciones raiz, y recursivamente se irán generando el resto de opciones según los permisos
        for (const item of this.fullMenuOptions) {
            this.createUserMenuOpcion(item);
        }
    }

    protected createUserMenuOpcion(item: ItiMenuItem, parent?: ItiMenuItem) {

        if (this.hasPermiso(item.permission)) {

            // Creamos una copia de la opción
            const newItem: ItiMenuItem = this.newMenuItem(item);

            if (this.hasSubmenuOptions(item)) {
                // Añadimos sus opciones de submenu
                for (const child of item.children) {
                    this.createUserMenuOpcion(child, newItem);
                }
            }

            // Añadimos la opción si procede
            this.AddUserMenuOpcion(newItem, parent);
        }
    }

    protected AddUserMenuOpcion(newItem: ItiMenuItem, parent?: ItiMenuItem) {
        // Solo añadiremos la opción si tiene ruta
        // o si tiene nodos hijos
        // Es decir, un nodo base (sin ruta) que no tenga hijos no debe aparecer porque no permite al usuario ir a ningún sitio
        if (this.hasRoute(newItem) || this.hasSubmenuOptions(newItem)) {

            // Añadimos el item como raíz o como hijo según sea el caso
            if (parent != null && parent.children != null) {
                parent.children.push(newItem);
            } else {
                this.menu.push(newItem);
            }
        }
    }


    protected hasPermiso(permiso: string | string[]): boolean {
        // Tienes permiso para ver una opción si:
        // - no se le configura permiso a la opción
        // - o si se especifica un permiso, y este está en la lista de permisos de usuario
        // - o si se especifica N permisos, y alguno de ellos está en la lista de permisos de usuario
        if (!Array.isArray(permiso)) {
            if (ItiString.IsNullOrWhiteSpace(permiso as string)) {
                return true;
            } else {
                return itiPermissionService.hasPermission(permiso as string);
            }
        } else {
            return (permiso as string[]).some((x) => itiPermissionService.hasPermission(x));
        }
    }

    protected hasSubmenuOptions(item: ItiMenuItem): boolean {
        return item.children != null && item.children.length > 0;
    }

    protected hasRoute(item: ItiMenuItem): boolean {
        const hasLink = item.link != null && !ItiString.IsNullOrWhiteSpace(item.link as string);
        const hasHref = item.href != null && !ItiString.IsNullOrWhiteSpace(item.href as string);
        return hasLink || hasHref;
    }

    protected newMenuItem(item: ItiMenuItem): ItiMenuItem {
        const newItem = new ItiMenuItem();
        newItem.icon = item.icon;
        newItem.text = item.text;
        newItem.i18n = item.i18n;
        newItem.link = item.link;
        newItem.href = item.href;
        newItem.target = item.target;
        newItem.img = item.img;
        newItem.tooltipi18n = item.tooltipi18n;
        newItem.permission = item.permission;
        newItem.children = [];
        return newItem;
    }
}